import {ProgramType} from 'gabi-api-ts/v2/hcp/common/hcp_common';

type HcpProgramConfig = {
    pulseRate: {
        spot: boolean;
        average: boolean;
        eventsBelow: boolean;
        eventsAbove: boolean;
    }
    spo2: {
        spot: boolean;
        average: boolean;
        eventsBelow: boolean;
    }
    bloodPressure: {
        spot: boolean;
    }
    respiratoryRate: {
        spot: boolean;
    }
    news2: {
        spot: boolean;
    }
    movements: boolean;
    sleeping: boolean;
}

function getHcpProgramConfig(program: ProgramType): HcpProgramConfig {
    if (program === ProgramType.HINLAB) {
        return {
            pulseRate: {
                average: false,
                eventsBelow: false,
                eventsAbove: false,
                spot: true,
            },
            spo2: {
                average: false,
                eventsBelow: false,
                spot: true,
            },
            bloodPressure: {
                spot: true,
            },
            respiratoryRate: {
                spot: true,
            },
            news2: {
                spot: true,
            },
            movements: false,
            sleeping: false,
        };
    }

    const config: HcpProgramConfig = {
        pulseRate: {
            average: true,
            eventsBelow: true,
            eventsAbove: true,
            spot: false,
        },
        spo2: {
            average: true,
            eventsBelow: true,
            spot: false,
        },
        bloodPressure: {
            spot: false,
        },
        respiratoryRate: {
            spot: false,
        },
        news2: {
            spot: false,
        },
        movements: true,
        sleeping: true,
    };
    if (program === ProgramType.CARDIAC) {
        config.spo2.eventsBelow = false;
    }

    if (program === ProgramType.PNEUMO) {
        config.pulseRate.eventsBelow = false;
        config.pulseRate.eventsAbove = false;
    }

    return config;
}

export {getHcpProgramConfig};
export type {HcpProgramConfig};
